import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import moment from "moment";
import { toast } from "react-toastify";
import { handleBudgetRequestStatus } from "../../../utility/CommonFunctions";
import ApproveRejectModal from "../../../components/comman/ApproveRejectModal";
import Logs from "../../Logs/Logs";
import BgBlurLoader from "../../../components/Loaders/BgBlurLoader";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import MainHeading from "../../../components/comman/MainHeading";
import CheckIcon from "../../../components/Icons/CheckIcon";
import CrossIcon from "../../../components/Icons/CrossIcon";
import DayBookIcon from "../../../components/Icons/DayBookIcon";

export default function BudgetRequestDetail() {
  let { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(true);
  const [budgetReqData, setBudgetReqData] = useState();
  const [modalType, setModalType] = useState("");
  const [modal, setModal] = useState(false);
  const toggle = () => {
    setModal(!modal);
  };
  const [refreshLogs, setRefreshLogs] = useState(false);

  useEffect(() => {
    GetBudgetRequestDetail();
  }, [id]);

  const GetBudgetRequestDetail = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl?.get_site_budget_request_detail + `budgetRequestId=${id}`;
    setDataLoading(true);
    callApi(API, options).then((response) => {
      setDataLoading(false);
      if (response?.status === true) {
        setBudgetReqData(response?.data);
      } else {
        toast.error(response?.message);
      }
    });
  };

  const handleReqStatus = (status, reason = "") => {
    let postData = {
      from: "SCM",
      status: status === "Rejected" ? "rejected" : "approved",
      ...(status === "Rejected" && { rejectReason: reason }),
    };
    const option = {
      method: "POST",
      data: postData,
    };

    setIsLoading(true);
    callApi(
      apiUrl.update_site_budget_request_status + `budgetRequestId=${id}`,
      option
    )
      .then((res) => {
        setIsLoading(false);
        if (res?.status === true) {
          toast.success(res?.message);
          GetBudgetRequestDetail();
          setRefreshLogs(true);
        } else {
          toast.error(res?.message);
        }
        toggle();
      })
      .catch((err) => {
        console.error(err);
        setIsLoading(false);
      });
  };

  const totalBudgetAmount =
    budgetReqData?.BudgetRequestHeads?.reduce(
      (sum, head) => sum + (Number(head?.amount) || 0),
      0
    ) || 0;

  const totalHeadsCount = budgetReqData?.BudgetRequestHeads?.length || 0;

  const groupedHeads =
    budgetReqData?.BudgetRequestHeads &&
    budgetReqData?.BudgetRequestHeads.length > 0
      ? Object.entries(
          budgetReqData.BudgetRequestHeads.reduce((acc, head) => {
            const type = head.type || "Other";
            if (!acc[type]) acc[type] = [];
            acc[type].push(head);
            return acc;
          }, {})
        )
      : [];

  return (
    <>
      {(dataLoading || isLoading) && <BgBlurLoader />}
      <div className="content container-fluid pb-5">
        {/* Main Heading */}
        <MainHeading title="Budget Request Detail" showBackButton={true} />

        {/* Master Summary Card */}
        <div
          className="card border-0 shadow-sm rounded-3 mb-4"
          style={{ background: "#ffffff" }}
        >
          <div className="card-body p-4">
            {/* Top Identity Strip */}
            <div
              className="d-flex align-items-start justify-content-between flex-wrap gap-3 pb-3 border-bottom"
              style={{ borderColor: "#f1f5f9" }}
            >
              <div className="d-flex align-items-center gap-3">
                <div
                  className="d-inline-flex align-items-center justify-content-center rounded-3 p-2.5 flex-shrink-0"
                  style={{
                    background: "#eff6ff",
                    color: "#2563eb",
                    width: "52px",
                    height: "52px",
                    border: "1px solid #bfdbfe",
                  }}
                >
                  <DayBookIcon />
                </div>

                <div>
                  <div className="d-flex align-items-center gap-2 flex-wrap">
                    <h3
                      className="mb-0 fw-bold text-dark"
                      style={{ letterSpacing: "-0.02em", fontSize: "1.35rem" }}
                    >
                      {budgetReqData?.budgetRequestNumber || "--"}
                    </h3>
                    {budgetReqData?.status && (
                      <span className="d-inline-flex">
                        {handleBudgetRequestStatus(budgetReqData.status)}
                      </span>
                    )}
                    <span
                      className="badge rounded-pill px-2.5 py-1 fw-semibold"
                      style={{
                        fontSize: "12px",
                        background:
                          budgetReqData?.type == 1 ? "#eff6ff" : "#fef3c7",
                        color:
                          budgetReqData?.type == 1 ? "#1d4ed8" : "#b45309",
                        border: `1px solid ${
                          budgetReqData?.type == 1 ? "#bfdbfe" : "#fde68a"
                        }`,
                      }}
                    >
                      {budgetReqData?.type == 1
                        ? "New Budget Request"
                        : "Budget Update Request"}
                    </span>
                  </div>

                  <div className="text-secondary small mt-1 d-flex align-items-center gap-2 flex-wrap">
                    <span className="d-inline-flex align-items-center gap-1">
                      <span>🏗️</span>
                      <span className="fw-medium text-dark">
                        {budgetReqData?.site?.name || "Site Not Specified"}
                      </span>
                    </span>
                    <span>•</span>
                    <span className="d-inline-flex align-items-center gap-1">
                      <span>👤</span>
                      <span>
                        {budgetReqData?.user?.name || "--"}{" "}
                        {budgetReqData?.user?.designation?.name && (
                          <span className="text-muted">
                            ({budgetReqData.user.designation.name}
                            {budgetReqData?.user?.department?.name
                              ? ` - ${budgetReqData.user.department.name}`
                              : ""}
                            )
                          </span>
                        )}
                      </span>
                    </span>
                    <span>•</span>
                    <span className="d-inline-flex align-items-center gap-1">
                      <span>📅</span>
                      <span>
                        {budgetReqData?.createdAt
                          ? moment(budgetReqData.createdAt).format("DD MMM YYYY")
                          : "--"}
                      </span>
                    </span>
                  </div>
                </div>
              </div>

              {/* Quick Quantitative Stats & Top Actions */}
              <div className="d-flex align-items-center gap-2 flex-wrap">
                <div
                  className="px-3.5 py-2 rounded-2 text-center"
                  style={{
                    background: "#f0fdf4",
                    border: "1px solid #bbf7d0",
                    minWidth: "155px",
                  }}
                >
                  <div
                    className="text-success text-uppercase"
                    style={{
                      fontSize: "10px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Total Estimated Budget
                  </div>
                  <div
                    className="fw-bold text-success text-truncate"
                    style={{
                      fontSize: "16px",
                      lineHeight: "1.2",
                      marginTop: "2px",
                    }}
                  >
                    ₹
                    {totalBudgetAmount.toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </div>
                </div>

                <div
                  className="px-3.5 py-2 rounded-2 text-center"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                    minWidth: "120px",
                  }}
                >
                  <div
                    className="text-secondary text-uppercase"
                    style={{
                      fontSize: "10px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Financial Year
                  </div>
                  <div
                    className="fw-bold text-dark text-truncate"
                    style={{
                      fontSize: "14px",
                      lineHeight: "1.2",
                      marginTop: "2px",
                    }}
                  >
                    {budgetReqData?.financialYear || "--"}
                  </div>
                </div>

                <div
                  className="px-3.5 py-2 rounded-2 text-center"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                    minWidth: "100px",
                  }}
                >
                  <div
                    className="text-secondary text-uppercase"
                    style={{
                      fontSize: "10px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Total Heads
                  </div>
                  <div
                    className="fw-bold text-primary"
                    style={{
                      fontSize: "16px",
                      lineHeight: "1.2",
                      marginTop: "2px",
                    }}
                  >
                    {totalHeadsCount}
                  </div>
                </div>

                {budgetReqData?.canChangeStatus && (
                  <div className="d-flex align-items-center gap-1.5 ms-sm-2">
                    <button
                      onClick={() => {
                        setModalType("reject");
                        toggle();
                      }}
                      className="btn btn-outline-danger d-inline-flex align-items-center gap-1.5 fw-semibold px-3 py-2 rounded-2"
                      type="button"
                    >
                      <CrossIcon width="12" height="12" />
                      <span>Reject</span>
                    </button>
                    <button
                      onClick={() => {
                        setModalType("approve");
                        toggle();
                      }}
                      className="btn btn-success d-inline-flex align-items-center gap-1.5 fw-semibold px-3 py-2 rounded-2"
                      type="button"
                    >
                      <CheckIcon />
                      <span>Approve</span>
                    </button>
                  </div>
                )}
              </div>
            </div>

            {/* Key Information Grid */}
            <div className="row g-3 pt-3">
              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Budget Request No.
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={budgetReqData?.budgetRequestNumber}
                    style={{ fontSize: "13.5px" }}
                  >
                    {budgetReqData?.budgetRequestNumber || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Unique Request ID
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Site Name
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={budgetReqData?.site?.name}
                    style={{ fontSize: "13.5px" }}
                  >
                    {budgetReqData?.site?.name || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Allocated Location
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Financial Year
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={budgetReqData?.financialYear}
                    style={{ fontSize: "13.5px" }}
                  >
                    {budgetReqData?.financialYear || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Fiscal Accounting Period
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Request Type
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    style={{ fontSize: "13.5px" }}
                  >
                    {budgetReqData?.type == 1
                      ? "New Budget Request"
                      : "Budget Update Request"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Classification
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Created By
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={budgetReqData?.user?.name}
                    style={{ fontSize: "13.5px" }}
                  >
                    {budgetReqData?.user?.name || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5 text-truncate"
                    style={{ fontSize: "11px" }}
                  >
                    {budgetReqData?.user?.designation?.name
                      ? `${budgetReqData.user.designation.name}${
                          budgetReqData?.user?.department?.name
                            ? ` (${budgetReqData.user.department.name})`
                            : ""
                        }`
                      : "Request Originator"}
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Creation Date
                  </div>
                  <div
                    className="fw-semibold text-dark"
                    style={{ fontSize: "13.5px" }}
                  >
                    {budgetReqData?.createdAt
                      ? moment(budgetReqData.createdAt).format(
                          "DD MMM YYYY, h:mm a"
                        )
                      : "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Timestamp Logged
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Current Status
                  </div>
                  <div className="mt-0.5">
                    {budgetReqData?.status
                      ? handleBudgetRequestStatus(budgetReqData.status)
                      : "--"}
                  </div>
                  <div
                    className="text-secondary small mt-1"
                    style={{ fontSize: "11px" }}
                  >
                    Lifecycle Stage
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Total Head Count
                  </div>
                  <div
                    className="fw-semibold text-dark"
                    style={{ fontSize: "13.5px" }}
                  >
                    {totalHeadsCount} Budget Heads
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Allocated Items
                  </div>
                </div>
              </div>

              {budgetReqData?.rejectReason && (
                <div className="col-12">
                  <div
                    className="p-3 rounded-2 bg-danger-subtle border border-danger-subtle text-danger"
                    style={{ fontSize: "13px" }}
                  >
                    <div
                      className="fw-bold text-uppercase mb-1 d-flex align-items-center gap-1.5"
                      style={{ fontSize: "11px", letterSpacing: "0.05em" }}
                    >
                      <span>⚠️</span>
                      <span>Rejection Reason</span>
                    </div>
                    <div style={{ lineHeight: "1.5" }}>
                      {budgetReqData.rejectReason}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Grouped Budget Request Heads */}
        {groupedHeads.length > 0 ? (
          groupedHeads.map(([type, heads], groupIndex) => {
            const groupSubtotal = heads.reduce(
              (sum, h) => sum + (Number(h?.amount) || 0),
              0
            );
            return (
              <div
                key={groupIndex}
                className="card border-0 shadow-sm rounded-3 mb-4 overflow-hidden"
                style={{ background: "#ffffff" }}
              >
                <div
                  className="card-header bg-white py-3 px-4 d-flex align-items-center justify-content-between flex-wrap gap-2 border-bottom"
                  style={{ borderColor: "#f1f5f9" }}
                >
                  <div className="d-flex align-items-center gap-2.5">
                    <div
                      className="rounded-2 p-1.5 d-flex align-items-center justify-content-center"
                      style={{
                        background: "#f1f5f9",
                        color: "#475569",
                        width: "34px",
                        height: "34px",
                      }}
                    >
                      📊
                    </div>
                    <div>
                      <div className="d-flex align-items-center gap-2">
                        <h5
                          className="mb-0 fw-bold text-dark text-capitalize"
                          style={{ fontSize: "15px" }}
                        >
                          {type.replace(/([A-Z])/g, " $1").trim()}
                        </h5>
                        <span
                          className="badge rounded-pill bg-light text-secondary border px-2.5 py-1"
                          style={{ fontSize: "11px", fontWeight: 600 }}
                        >
                          {heads.length} {heads.length === 1 ? "Head" : "Heads"}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    <span
                      className="text-secondary small fw-medium"
                      style={{ fontSize: "12px" }}
                    >
                      Subtotal:
                    </span>
                    <span
                      className="fw-bold text-primary"
                      style={{ fontSize: "15px" }}
                    >
                      ₹
                      {groupSubtotal.toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </span>
                  </div>
                </div>

                <div className="table-responsive">
                  <table
                    className="table align-middle mb-0"
                    style={{ borderCollapse: "separate", borderSpacing: "0" }}
                  >
                    <thead style={{ background: "#f8fafc" }}>
                      <tr>
                        <th
                          style={{
                            width: "55px",
                            padding: "12px 16px",
                            fontSize: "11px",
                            fontWeight: 700,
                            textTransform: "uppercase",
                            letterSpacing: "0.05em",
                            color: "#64748b",
                          }}
                        >
                          #
                        </th>
                        <th
                          style={{
                            minWidth: "220px",
                            padding: "12px 16px",
                            fontSize: "11px",
                            fontWeight: 700,
                            textTransform: "uppercase",
                            letterSpacing: "0.05em",
                            color: "#64748b",
                          }}
                        >
                          {type === "staffBudget"
                            ? "Department"
                            : "Expense Head"}
                        </th>
                        <th
                          style={{
                            minWidth: "250px",
                            padding: "12px 16px",
                            fontSize: "11px",
                            fontWeight: 700,
                            textTransform: "uppercase",
                            letterSpacing: "0.05em",
                            color: "#64748b",
                          }}
                        >
                          Description
                        </th>
                        <th
                          className="text-end"
                          style={{
                            width: "180px",
                            padding: "12px 16px",
                            fontSize: "11px",
                            fontWeight: 700,
                            textTransform: "uppercase",
                            letterSpacing: "0.05em",
                            color: "#64748b",
                          }}
                        >
                          Expected Amount
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {heads.map((head, index) => (
                        <tr
                          key={index}
                          style={{ borderBottom: "1px solid #f1f5f9" }}
                        >
                          <td
                            className="text-secondary"
                            style={{ padding: "14px 16px", fontSize: "13px" }}
                          >
                            {index + 1}
                          </td>
                          <td style={{ padding: "14px 16px" }}>
                            <div
                              className="fw-semibold text-dark"
                              style={{ fontSize: "13.5px" }}
                            >
                              {head?.expensehead?.name ||
                                head?.department?.name ||
                                "--"}
                            </div>
                            <div
                              className="text-secondary small mt-0.5"
                              style={{ fontSize: "11px" }}
                            >
                              {head?.type === "staffBudget"
                                ? "Department Allocation"
                                : "Expense Head Category"}
                            </div>
                          </td>
                          <td
                            style={{
                              padding: "14px 16px",
                              fontSize: "13px",
                              color: "#475569",
                            }}
                          >
                            {head?.description || "--"}
                          </td>
                          <td
                            className="text-end"
                            style={{ padding: "14px 16px" }}
                          >
                            <div
                              className="fw-bold text-dark"
                              style={{ fontSize: "14px" }}
                            >
                              ₹
                              {Number(head?.amount || 0).toLocaleString(
                                "en-IN",
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot style={{ background: "#f8fafc" }}>
                      <tr>
                        <td
                          colSpan={3}
                          className="text-end fw-semibold text-secondary"
                          style={{ padding: "12px 16px", fontSize: "12.5px" }}
                        >
                          Subtotal for {type.replace(/([A-Z])/g, " $1").trim()}:
                        </td>
                        <td
                          className="text-end fw-bold text-primary"
                          style={{ padding: "12px 16px", fontSize: "14.5px" }}
                        >
                          ₹
                          {groupSubtotal.toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            );
          })
        ) : (
          <div
            className="card border-0 shadow-sm rounded-3 mb-4 p-5 text-center text-muted"
            style={{ background: "#ffffff" }}
          >
            <div style={{ fontSize: "28px", opacity: 0.5 }}>📊</div>
            <div className="mt-2 fw-medium">No Budget Heads Found</div>
          </div>
        )}

        {/* Description & Justification Card */}
        {budgetReqData?.description && (
          <div
            className="card border-0 shadow-sm rounded-3 mb-4 overflow-hidden"
            style={{ background: "#ffffff" }}
          >
            <div
              className="card-header bg-white py-3 px-4 d-flex align-items-center gap-2 border-bottom"
              style={{ borderColor: "#f1f5f9" }}
            >
              <span style={{ fontSize: "16px" }}>📝</span>
              <h5
                className="mb-0 fw-bold text-dark"
                style={{ fontSize: "15px" }}
              >
                Description & Justification
              </h5>
            </div>
            <div className="card-body p-4">
              <div
                className="border rounded-2 p-2"
                style={{ background: "#ffffff" }}
              >
                <CKEditor
                  editor={ClassicEditor}
                  data={budgetReqData?.description || ""}
                  disabled={true}
                  config={{
                    toolbar: [],
                    readOnly: true,
                    image: {
                      toolbar: [
                        "imageStyle:alignLeft",
                        "imageStyle:alignCenter",
                        "imageStyle:alignRight",
                        "|",
                        "imageTextAlternative",
                      ],
                    },
                  }}
                />
              </div>
            </div>
          </div>
        )}

        {/* Bottom Reviewer Action Bar (when approval permitted) */}
        {budgetReqData?.canChangeStatus && (
          <div
            className="card border-0 shadow-sm rounded-3 mb-4 p-3 d-flex flex-row align-items-center justify-content-between flex-wrap gap-3"
            style={{ background: "#f8fafc", border: "1px solid #e2e8f0" }}
          >
            <div className="d-flex align-items-center gap-2.5">
              <span style={{ fontSize: "22px" }}>⚖️</span>
              <div>
                <div
                  className="fw-bold text-dark"
                  style={{ fontSize: "14px" }}
                >
                  Approval Decision Pending
                </div>
                <div
                  className="text-secondary small"
                  style={{ fontSize: "12px" }}
                >
                  You are authorized to approve or reject this budget request.
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center gap-2">
              <button
                onClick={() => {
                  setModalType("reject");
                  toggle();
                }}
                className="btn btn-outline-danger d-inline-flex align-items-center gap-1.5 fw-semibold px-4 py-2 rounded-2"
                type="button"
              >
                <CrossIcon width="12" height="12" />
                <span>Reject Request</span>
              </button>
              <button
                onClick={() => {
                  setModalType("approve");
                  toggle();
                }}
                className="btn btn-success d-inline-flex align-items-center gap-1.5 fw-semibold px-4 py-2 rounded-2"
                type="button"
              >
                <CheckIcon />
                <span>Approve Request</span>
              </button>
            </div>
          </div>
        )}

        {/* Audit Logs */}
        <Logs
          type={"budgetRequest"}
          id={id}
          refreshLogs={refreshLogs}
          setRefreshLogs={setRefreshLogs}
        />
      </div>

      <ApproveRejectModal
        modal={modal}
        toggle={toggle}
        submitHandler={(reason) =>
          handleReqStatus(
            modalType === "reject" ? "Rejected" : "Approved",
            reason
          )
        }
        isLoading={isLoading}
        actionType={modalType}
      />
    </>
  );
}
